import axios from 'axios';
import Authorization from './authorization';
import EnvironmentService from './environment';

const api = axios.create({
    baseURL: `${EnvironmentService.baseURL()}/api`,
    timeout: 25000,
    responseType: 'json',
});

class ChatService {
    static async listInbox() {
        const headers = await Authorization.authorizationHeader();
        return await api.get('/chat/inbox', { headers });
    }

    // The API returns messages newest-first, capped at 25 per page. Pass the `nextKey`
    // from the previous response's `paging` to walk further back through the history.
    static async listConversation(recipientSub, { limit, nextKey } = {}) {
        const headers = await Authorization.authorizationHeader();
        const params = {};
        if (limit) params.limit = limit;
        if (nextKey) params.nextKey = nextKey;
        return await api.get(`/chat/user/${recipientSub}`, { headers, params });
    }

    static async purchaseChatMessage({ senderSub, sentAt }) {
        const headers = await Authorization.authorizationHeader();
        return await api.post('/purchases/chat-purchase', { senderSub, sentAt }, { headers });
    }

    static async confirmChatMessagePurchase({ paymentIntentId, senderSub, sentAt }) {
        const headers = await Authorization.authorizationHeader();
        return await api.post('/purchases/chat-purchase/confirm', { paymentIntentId, senderSub, sentAt }, { headers });
    }
}

export default ChatService;
